import { render, staticRenderFns } from "./planlist.vue?vue&type=template&id=a163fc86"
import script from "./planlist.vue?vue&type=script&lang=js"
export * from "./planlist.vue?vue&type=script&lang=js"
import style0 from "./planlist.vue?vue&type=style&index=0&id=a163fc86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports